/**
 * Recovery for a lazy chunk that fails to load.
 *
 * The usual cause is a deploy: dist/ is swapped atomically, so an open tab
 * asking for a chunk under its old hashed name gets a 404. Reloading pulls the
 * new index.html and fixes it — as long as the reload cannot be answered from
 * the service worker's copy of the old one, which is what `swCache` handles.
 *
 * The other cause is no network — an offline visit to a route whose chunk was
 * deliberately left out of the service worker precache. Reloading cannot fix
 * that, and reloading unconditionally would spin: load route → import fails →
 * reload → same route → import fails. So the reload fires at most once per tab.
 */

import { reloadWithoutCachedShell } from './swCache';

const RELOAD_GUARD_KEY = 'translate-ai:preloadReload';

export function handlePreloadError(): void {
  try {
    if (sessionStorage.getItem(RELOAD_GUARD_KEY)) return;
    sessionStorage.setItem(RELOAD_GUARD_KEY, '1');
  } catch {
    // Private-mode or storage-disabled browsers: one unguarded reload is still
    // better than leaving a stale tab that can never load the route.
  }
  reloadWithoutCachedShell();
}
